import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import config from '../../helpers/config';



export default (props) => {
    
    return (
        <div>
            <Grid container alignItems="center" justify="center">
                <img src={`${config.S3Endpoint}/logo.png`} style={{width: 350, margin: '0 auto'}}/>
            </Grid>
            
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/client/components/Logo.js